import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "20",
  fill: "none",
  viewBox: "0 0 19 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m18.942 7.442-.195-.566a9.6 9.6 0 0 0-.762-1.681 9.8 9.8 0 0 0-1.075-1.503l-.394-.453-3.485.935L12.1.694 11.512.58A9.6 9.6 0 0 0 7.83.578l-.585.117-.933 3.477-3.48-.93-.393.452A9.5 9.5 0 0 0 .6 6.878l-.195.567 2.547 2.547L.4 12.545l.196.567c.205.596.463 1.162.763 1.682.305.525.666 1.03 1.075 1.5l.394.453 3.484-.933.932 3.476.586.116a9.6 9.6 0 0 0 3.68.004l.589-.115.932-3.481 3.48.93.394-.45a9.6 9.6 0 0 0 1.837-3.185l.196-.567-2.547-2.547zm-9.273 4.95a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8"
    }, null, -1)
  ])))
}
export default { render: render }